import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {
  changeHandler,
  setDeliveryNotes,
  setCurrentStep,
  stepEnum,
  getPickUpDeliveryTimeSlots,
  clearDeliverySlots,
  formName,
  notificationType,
  saveSelectedDeliverySlot,
  createDeliveryNotification,
  dispatchType,
  saveToHistory,
  setAutoFillValues,
} from '../IMEIDeviceRepairSlice';
import Title from '../Shared/Title';
import AddressFrm from '../../../Shared/AddressFrm/AddressFrm';
import {clearAddress} from '../../../Shared/AddressFrm/addressFrmSlice';
import TimeSlotSelection from '../Shared/TimeSlotSelection';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import PickUpDeliveryContactPerson from './../Shared/PickupDeliveryContactPerson';
import {convertSlotDataToDlvDate} from 'app/utilities/StringHelpers/StringHelpers';
import {
  dwhDeliveryAddressPageDisplayed,
  dwhDeliveryAddressButtonClick,
  dwhDeliveryAddressAndDatePageDisplayed,
  dwhDeliveryAddressAndDateButtonClick,
  dwhIDFDeliveryAddressAndDatePageDisplayed,
  dwhIDFDeliveryAddressAndDateButtonClick,
  dwhPrivateReturnAddressPageDisplayed,
  dwhPrivateReturnAddressPageButtonClick,
} from '../reports/dwhReports';
import {gtag4} from 'app/utilities/analytics/tracking';
import CheckBox from '../../../Shared/CheckBox/Checkbox';
import TextInput from 'app/Components/Shared/TextInput/TextInput';

const DeliveryAddressSelection = (props) => {
  const [getSlotsButton, activateGetSlotsButton] = useState(false);
  const [autoFillAddress, setAutoFillAddress] = useState(false);
  const {selectedAccountOrgName, selectedIMEI, deliveryPrice, causeList} = props.deviceRepairData;
  const {securityCode, alternatePhone} = props.deviceRepairData.selectCauseForm;

  const selectedHetPay = props.deviceRepairData.dwhData.selectedHetPay;
  const customerName = props.deviceRepairData.dwhData.customerName;
  const subscriber = props.deviceRepairData.dwhData.subscriber;
  const phone = props.deviceRepairData.selectedPhoneNumber;
  const param2 = props.deviceRepairData.selectCauseForm.causeList[0].selectedCauseType;
  const param3 = props.deviceRepairData.selectCauseForm.causeList[0].selectedCauseSubType;
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    props.clearAddress(props.addressForm);
    props.saveToHistory('delivery');

    if (!props.isPrivate) {
      dwhDeliveryAddressPageDisplayed({
        selectedHetPay,
        customerName,
        subscriber,
        phone,
        param2,
        param3,
      });
    } else if (props.contentData.isFromPrivateSelfcare.value) {
      dwhPrivateReturnAddressPageDisplayed({
        selectedHetPay,
        subscriber,
        selectedIMEI,
        causeList,
        alternatePhone,
        securityCode,
        deliveryPrice,
        customerName,
        selectedAccountOrgName,
      });
    }
  }, []);

  useEffect(() => {
    if (props.addressForm.form.city && props.addressForm.form.street && props.addressForm.form.home) {
      activateGetSlotsButton(true);
      if (validateAddressChanges()) {
        props.clearDeliverySlots();
      }
    } else {
      props.clearDeliverySlots();
      activateGetSlotsButton(false);
    }
  }, [props.addressForm.form.city, props.addressForm.form.street, props.addressForm.form.home]);

  useEffect(() => {
    if (getSlotsButton && props.deviceRepairData.deliveryTimeSlots) {
      if (props.isPrivate) {
        dwhIDFDeliveryAddressAndDatePageDisplayed({customerName, subscriber, param2, param3});
      } else if (props.contentData.isFromPrivateSelfcare.value) {
        dwhPrivateReturnAddressPageButtonClick({
          selectedHetPay,
          subscriber,
          selectedIMEI,
          causeList,
          alternatePhone,
          securityCode,
          deliveryPrice,
          customerName,
          selectedAccountOrgName,
        });
      } else {
        dwhDeliveryAddressAndDatePageDisplayed({
          selectedHetPay,
          customerName,
          subscriber,
          phone,
          param2,
          param3,
        });
      }
    }
  }, [getSlotsButton, props.deviceRepairData.deliveryTimeSlots]);

  function handleInputChange(e) {
    const name = e.target.getAttribute('name');
    const rule = props.deviceRepairData.deliveryAddressForm.rules[name];
    const value = e.target.value;
    const form = formName.deliveryAddressForm;

    props.changeHandler({
      name,
      value,
      rule,
      form,
    });
  }

  const submitDeliveryAddress = () => {
    if (validateRequest()) {
      if (props.isPrivate) {
        dwhIDFDeliveryAddressAndDateButtonClick({customerName, subscriber, param2, param3});
      } else if (props.contentData.isFromPrivateSelfcare.value) {
        dwhPrivateReturnAddressPageButtonClick({
          selectedHetPay,
          subscriber,
          selectedIMEI,
          causeList,
          alternatePhone,
          securityCode,
          deliveryPrice,
          customerName,
          selectedAccountOrgName,
        });
      } else {
        dwhDeliveryAddressAndDateButtonClick({
          selectedHetPay,
          customerName,
          subscriber,
          phone,
          param2,
          param3,
        });
      }
      const createNotReq = {
        selectedNumber: props.deviceRepairData.selectedPhoneNumber,
        street: autoFillAddress ? props.deviceRepairData.deliveryAddressForm.street : props.addressForm.form.streetName,
        city: autoFillAddress ? props.deviceRepairData.deliveryAddressForm.city : props.addressForm.form.cityName,
        houseNum: autoFillAddress ? props.deviceRepairData.deliveryAddressForm.homeNum : props.addressForm.form.home,
        apartmentNum: autoFillAddress ? props.deviceRepairData.deliveryAddressForm.apartment : props.addressForm.form.apartment,
        contactPersonName: props.deviceRepairData.deliveryAddressForm.deliveryContactName,
        contactPersonLastName: props.deviceRepairData.deliveryAddressForm.deliveryContactLastName,
        contactPersonPhone: props.deviceRepairData.deliveryAddressForm.deliveryContactPhone,
        notes: props.deviceRepairData.deliveryAddressForm.deliveryNotes,
        refOrder: props.deviceRepairData.createNotificationTicketNumber,
        dispLidRsn: `${props.deviceRepairData.deliveryAddressForm.deliveryTimeSlot.waitFrom}-${props.deviceRepairData.deliveryAddressForm.deliveryTimeSlot.waitTo}`,
        dlvDate: convertSlotDataToDlvDate(props.deviceRepairData.deliveryAddressForm.deliveryTimeSlot.lfdat),
        shipCond: props.deviceRepairData.deliveryAddressForm.deliveryTimeSlot.round,
        notificationType: notificationType.SEND,
        pickLocation: props.deviceRepairData.deliveryAddressForm.deliveryTimeSlot.pickLocation,
        lockCode: props.deviceRepairData.selectCauseForm.securityCode,
        alternatePhone: props.deviceRepairData.selectCauseForm.alternatePhone,
        clearContent: props.deviceRepairData.selectCauseForm.clearContent,
        isPrivate: props.deviceRepairData.isPrivate,
        isFromPrivateSelfCare: props.contentData.isFromPrivateSelfcare.value === true,
        selectedIMEI: selectedIMEI,
      };
      gtag4({
        event: 'DeviceRepair_DeliveryDayContinueButton',
        action: 'DeliveryDayContinueButton',
        button: 'אישור',
      });
      props.saveToHistory();
      props.createDeliveryNotification(createNotReq);
    }
  };

  const validateAddressChanges = () => {
    if (
      props.deviceRepairData.deliveryAddressForm.city &&
      props.deviceRepairData.deliveryAddressForm.city !== props.addressForm.form.cityName
    ) {
      return true;
    } else if (
      props.deviceRepairData.deliveryAddressForm.street &&
      props.deviceRepairData.deliveryAddressForm.street !== props.addressForm.form.streetName
    ) {
      return true;
    }
    if (
      props.deviceRepairData.deliveryAddressForm.homeNum &&
      props.deviceRepairData.deliveryAddressForm.homeNum !== props.addressForm.form.home
    ) {
      return true;
    } else return false;
  };

  const validateRequest = () => {
    let validForm = true;
    if (!props.deviceRepairData.deliveryAddressForm.deliveryContactName.trim()) {
      props.changeHandler({
        name: 'deliveryContactName',
        value: '',
        rule: props.deviceRepairData.deliveryAddressForm.rules.deliveryContactName,
        form: formName.deliveryAddressForm,
      });
      validForm = false;
    }
    if (!props.deviceRepairData.deliveryAddressForm.deliveryContactLastName.trim()) {
      props.changeHandler({
        name: 'deliveryContactLastName',
        value: '',
        rule: props.deviceRepairData.deliveryAddressForm.rules.deliveryContactLastName,
        form: formName.deliveryAddressForm,
      });
      validForm = false;
    }
    if (!props.deviceRepairData.deliveryAddressForm.deliveryContactPhone.trim()) {
      props.changeHandler({
        name: 'deliveryContactPhone',
        value: '',
        rule: props.deviceRepairData.deliveryAddressForm.rules.deliveryContactPhone,
        form: formName.deliveryAddressForm,
      });
      validForm = false;
    }
    if (!props.deviceRepairData.deliveryAddressForm.deliveryTimeSlot) {
      props.changeHandler({
        name: 'deliveryTimeSlot',
        value: null,
        rule: props.deviceRepairData.deliveryAddressForm.rules.deliveryTimeSlot,
        form: formName.deliveryAddressForm,
      });
      validForm = false;
    }

    return validForm;
  };

  const getTimeSlots = () => {
    dwhDeliveryAddressButtonClick({
      selectedHetPay,
      customerName,
      subscriber,
      phone,
      param2,
      param3,
    });
    const req = {
      city: autoFillAddress ? props.deviceRepairData.deliveryAddressForm.city : props.addressForm.form.cityName,
      street: autoFillAddress ? props.deviceRepairData.deliveryAddressForm.street : props.addressForm.form.streetName,
      homeNum: autoFillAddress ? props.deviceRepairData.deliveryAddressForm.homeNum : props.addressForm.form.home,
      dispatchType: dispatchType.SND,
      refOrder: props.deviceRepairData.pickUpTicketNumber,
    };
    props.getPickUpDeliveryTimeSlots(req);
  };

  const handleAutoFillChange = () => {
    setAutoFillAddress(!autoFillAddress);
    props.setAutoFillValues(!autoFillAddress);
    activateGetSlotsButton(!autoFillAddress);
    if (validateAddressChanges()) {
      props.clearDeliverySlots();
    }
    if (!autoFillAddress) {
      props.clearAddress(props.addressForm);
    }
  };

  return (
    <div className='delivery-address-wrapper'>
      <div className={'title-area'}>
        <Title text={'תאום שליחות לתיקון מכשיר'} />
        <span className={'sub-title'}>
          כתובת לתיאום השליחות <span className={'extra-bold'}>להחזרה</span>
        </span>
      </div>
      <div className='pickup-delivery-form'>
        <div className={'top-content'}>
          <div className={'title-area'}>
            <span className={'setup-address-title'}>מה הכתובת שלך?</span>
            <span className={'setup-address-subTitle'}>שדות עם כוכבית הם חובה</span>
          </div>
          <div className={'auto-fill-container'}>
            <CheckBox
              checked={autoFillAddress}
              label={`מילוי אוטומטי לפי הכתובת ממנה נאסף המכשיר`}
              id='autofill'
              onCheck={handleAutoFillChange}
              onUncheck={handleAutoFillChange}
            />
          </div>
        </div>
        {autoFillAddress ? (
          <div className={'autofilled-fields'}>
            <TextInput disabled={true} value={props.deviceRepairData.pickUpAddressForm.city} placeholder='שם יישוב' required='required' />
            <TextInput disabled={true} value={props.deviceRepairData.pickUpAddressForm.street} placeholder='רחוב' required='required' />
            <div className={'multiple-fields'}>
              <TextInput disabled={true} value={props.deviceRepairData.pickUpAddressForm.homeNum} placeholder='בית' required='required' />
              <TextInput disabled={true} value={props.deviceRepairData.pickUpAddressForm.apartmentNum} placeholder='דירה' />
            </div>
          </div>
        ) : (
          <AddressFrm
            title={' '}
            avoidGaReport={true}
            onError={() => props.setCurrentStep(stepEnum.ERROR)}
            noDefaultValuesOnRender={true}
          />
        )}
        <div className={` ${!getSlotsButton ? 'disabled-btn' : ''} w-100 d-flex justify-content-center get-slots-button`}>
          {props.deviceRepairData.deliveryTimeSlots === null && (
            <BtnSubmit text={'המשך'} onclick={() => (getSlotsButton ? getTimeSlots() : null)} />
          )}
        </div>
        {props.deviceRepairData.deliveryAddressForm.errors?.deliveryTimeSlot && (
          <div className='pickup-delivery-slot-error'>{props.deviceRepairData.deliveryAddressForm.errors?.deliveryTimeSlot}</div>
        )}

        {props.deviceRepairData.deliveryTimeSlots && getSlotsButton && (
          <>
            <TimeSlotSelection
              timeSlots={props.deviceRepairData.deliveryTimeSlots}
              name='selectedDeliveryTimeSlot'
              selected={props.deviceRepairData.deliveryAddressForm.deliveryTimeSlot?.key}
              changeHandler={props.saveSelectedDeliverySlot}
            />
            <PickUpDeliveryContactPerson
              form={props.deviceRepairData.deliveryAddressForm}
              contactNameForm={'deliveryContactName'}
              contactLastNameForm={'deliveryContactLastName'}
              contactPhoneForm={'deliveryContactPhone'}
              changeHandler={handleInputChange}
              contactNotesForm={'deliveryNotes'}
            />
            <div className='w-100 d-flex justify-content-center'>
              <BtnSubmit text={'אישור'} onclick={() => submitDeliveryAddress()} />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    deviceRepairData: state.iMEIDeviceRepair,
    addressForm: state.addressForm,
  };
};

const mapDispatchToProps = {
  setDeliveryNotes,
  changeHandler,
  setCurrentStep,
  getPickUpDeliveryTimeSlots,
  clearDeliverySlots,
  saveSelectedDeliverySlot,
  createDeliveryNotification,
  saveToHistory,
  setAutoFillValues,
  clearAddress,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryAddressSelection);
